module.exports = __webpack_public_path__ + "static/media/dennis-brendel-bSBJ7PYA3DU-unsplash.2446a706.jpg";